import { render, staticRenderFns } from "./CatalogueRow.vue?vue&type=template&id=4752b920&"
import script from "./CatalogueRow.vue?vue&type=script&lang=js&"
export * from "./CatalogueRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports